const isFranchiseValue = (value) => value === true || Number(value) === 1;

const getInventoryModifierBadges = ({
  country,
  inventoryClass,
  hasThreeChecks,
  isFranchise,
}) => {
  if (country !== 'MX' || inventoryClass !== 'captured') {
    return [];
  }

  const chips = [];
  if (isFranchiseValue(isFranchise)) {
    chips.push({ type: 'franchise' });
  } else if (Number(hasThreeChecks) === 1) {
    chips.push({ type: 'docs' });
  }
  return chips;
};

export default getInventoryModifierBadges;
